export default __webpack_public_path__ + "static/media/background2.a24b339d.png";